import { Observable } from 'rxjs/Observable';
import { BusinesLogicService } from './business-logic.service';
var SocketService = (function () {
    function SocketService(_blogic) {
        this._blogic = _blogic;
        this.sockets = {};
        this.messageObservables = {};
        this.closeObservables = {};
        this.openObservables = {};
        this.SERVER_URL = '';
        this.SERVER_URL = this._blogic.socketUrl;
    }
    SocketService.prototype.initSocket = function (desk_id, socket) {
        if (this.isSocketClosed(socket)) {
            var endpoint = this.getEndpointForSocket(socket);
            this.createSocketConnection(socket, desk_id, endpoint);
            this.setupSocketCloseHandler(socket);
            this.initObservables(socket);
        }
    };
    SocketService.prototype.isSocketClosed = function (socketType) {
        return !this.sockets[socketType] || this.sockets[socketType].readyState === WebSocket.CLOSED;
    };
    SocketService.prototype.getEndpointForSocket = function (socketType) {
        return socketType === 'msgSocket' ? 'chat' : 'notify';
    };
    SocketService.prototype.createSocketConnection = function (socketType, deskId, endpoint) {
        var url = "" + this.SERVER_URL + endpoint + "?id=" + deskId;
        this.sockets[socketType] = new WebSocket(url);
    };
    SocketService.prototype.setupSocketCloseHandler = function (socketType) {
        var _this = this;
        this.sockets[socketType].onclose = function () {
            _this.sockets[socketType] = null;
        };
    };
    SocketService.prototype.clearSocket = function (socket) {
        if (this.isSocketOpen(socket)) {
            this.sockets[socket].close();
        }
        this.sockets[socket] = null;
    };
    SocketService.prototype.isSocketOpen = function (socketType) {
        return this.sockets[socketType] && this.sockets[socketType].readyState === WebSocket.OPEN;
    };
    SocketService.prototype.initObservables = function (socket) {
        this.messageObservables[socket] = this.createMessageObservable(socket);
        this.closeObservables[socket] = this.createCloseObservable(socket);
        this.openObservables[socket] = this.createOpenObservable(socket);
    };
    SocketService.prototype.send = function (message, socket) {
        this.sockets[socket].send(JSON.stringify(message));
    };
    SocketService.prototype.getMessageObservable = function (socket) {
        return this.messageObservables[socket];
    };
    SocketService.prototype.getOpenObservable = function (socket) {
        return this.openObservables[socket];
    };
    SocketService.prototype.getCloseObservable = function (socket) {
        return this.closeObservables[socket];
    };
    SocketService.prototype.createMessageObservable = function (socket) {
        var _this = this;
        return new Observable(function (observer) {
            _this.sockets[socket].onmessage = function (data) {
                observer.next(JSON.parse(data.data));
            };
        }).share();
    };
    SocketService.prototype.createCloseObservable = function (socket) {
        var _this = this;
        return new Observable(function (observer) {
            _this.sockets[socket].onclose = function (data) {
                observer.next(data);
            };
        }).share();
    };
    SocketService.prototype.createOpenObservable = function (socket) {
        var _this = this;
        return new Observable(function (observer) {
            _this.sockets[socket].onopen = function (data) {
                observer.next(data);
            };
        }).share();
    };
    return SocketService;
}());
export { SocketService };
